import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
import { getMasterData, getmasterLocationDetails, saveLocationMaster,ResetLocationDetails } from './actions/LocationMasterActions';
import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { isInteger, isValidApartmentWithSpace, isValidNameWithSpace, normalizeDecimal, normalizeMobile, normalizeZipCode, renderAutoCompleteSingleSelect, renderTextArea, renderTextField, renderTimePicker } from '../../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import React from 'react';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { CONVERGENCY, displayCustomError, extractDataFromArrayByValue, showNormalizedRate } from '../../../../../src/actions/utilAction';
import GooglePlaceAutocomplete from '../../../../components/GooglePlaceAutocomplete';
import SmallLoader from '../../../../img/small-loader.gif';
import _ from 'lodash';
import { renderDateField } from '../../../../components/reduxFields';
const styles = {
  font: {
    fontStyle: 'ITALIC',    
  },
};


//const validatefacilityNPINumber = (value) => !(value ? value.trim() : value) ? 'Please enter facility NPI number' : (value ? value.trim() : value).length < 10 ? 'Please enter valid NPI number' : undefined;
const validateOtherTaxonomy = (value) => !(value ? value.trim() : value) ? 'Please enter taxonomy code' : undefined;
const validateFromDate = (value) => !(value ? value.trim() : value) ? 'Please Select From Date' : undefined;
const validateReimbursementRate = (value) => !(value ? value.trim() : value) ? 'Please Enter Reimbursement Rate ' : undefined;

class LocationMasterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      officeStartHour: null,
      officeEndHour: null,
      masterState: [],
      filteredStatesByCountry: [],
      locationID: props.locationId,
      street_number: '',
      route: '',
      locality: '',
      administrative_area_level_1: '',
      country: '',
      postal_code: '',
      latitude: 0.0,
      longitude: 0.0,
      isValidAddress: true,
      Address: null,
      standardTime: 0.0,
      daylightSavingTime: 0.0,
      Taxonomylist: [{ id: '106S00000X', value: '106S00000X - BT' }, { id: '106E00000X', value: '106E00000X - BCaBA'  },{ id: '103K00000X', value: '103K00000X - BCBA'  },{ id: 'Other', value: 'Other' }],
      displayOtherTaxonomy: false,
      startDate: [],
      endDate: [],
      fromDateRequired:false,
      reimbursementRateRequired:false
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this);
  }

  componentWillMount() {
    this.props.getMasterData();
    if (this.state.locationID) {
      this.props.getmasterLocationDetails(this.state.locationID);
    }
  };
  componentWillReceiveProps(nextProps) {
    this.props.dispatch(change('LocationMasterModalForm', 'mileageRate', `0.67 $`))
    if (nextProps.master_data && nextProps.master_data !== this.props.master_data) {
      this.setState({ masterState: nextProps.master_data.masterState || [] }, () => {
        if (nextProps.defaultSelectedCountry) {
          this.getFilteredStatesList(nextProps.defaultSelectedCountry);
        }
      });
    }
    if (nextProps.masterLocationDetails && nextProps.masterLocationDetails !== this.props.masterLocationDetails) {
      let data = nextProps.masterLocationDetails.data;
      this.setState({
        officeStartHour: data.officeStartHour || null,
        officeEndHour: data.officeEndHour || null,
        Address: data.address || '',
        latitude: data.latitude || 0.0,
        longitude: data.longitude || 0.0,
        standardTime: data.standardTime || 0.0,
        daylightSavingTime: data.daylightSavingTime || 0.0,
        displayOtherTaxonomy: ((data.taxonomyCode !== '106S00000X' && data.taxonomyCode !== '106E00000X' && data.taxonomyCode !== '103K00000X') ? true : false),
      });
      this.getFilteredStatesList(data.countryID);

      if (nextProps.locationId !== null) {
        if (nextProps.masterLocationDetails && nextProps.masterLocationDetails.data && nextProps.masterLocationDetails != this.props.masterLocationDetails) {
          let startDate = this.state.startDate;
          let endDate = this.state.endDate;
          (nextProps.masterLocationDetails.data.locationMileageReimbursementRateModel || []).forEach((obj, index) => {
            if (obj.fromDate != undefined) {
              _.update(startDate, `[${index}]`, function (n) {
                return moment(obj.fromDate).format('MM-DD-YYYY');
              });

              this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${index}].fromDate`, moment(obj.fromDate).format('MM-DD-YYYY') || null));
            }

            if (obj.toDate !== undefined) {
              _.update(endDate, `[${index}]`, function (n) {
                return moment(obj.toDate).format('MM-DD-YYYY');
              });

              this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${index}].toDate`, obj.toDate || null));
            }

            if (obj.reimbursementRate !== undefined) {
              this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${index}].reimbursementRate`, obj.reimbursementRate || null));
            }

          });

          this.setState({ startDate: startDate, endDate: endDate });

        }

        // if (nextProps.masterLocationDetails && nextProps.masterLocationDetails.data && nextProps.masterLocationDetails != this.props.masterLocationDetails) {
        //   this.props.dispatch(change('LocationMasterModalForm', 'mileageRate', `${nextProps.masterLocationDetails.data.mileageRate} $` || 'NA'))
        // }
      }   
      
    }
    
    

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

 

  IsFullAddressEmpty(searchText) {
    if (searchText.length === 0)
      this.setState({ isValidAddress: false });
  }

  GetFullAddress(componentForm) {
    this.setState({
      street_number: componentForm.street_number,
      route: componentForm.route,
      locality: componentForm.locality,
      administrative_area_level_1: componentForm.administrative_area_level_1,
      country: componentForm.country,
      postal_code: componentForm.postal_code,
      latitude: componentForm.lat,
      longitude: componentForm.lng,
      isValidAddress: true,
    }, () => {
      this.props.dispatch(change('LocationMasterModalForm', 'city', this.state.locality === 'long_name' ? '' : this.state.locality));
      this.props.dispatch(change('LocationMasterModalForm', 'zip', this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
      let countryObj = extractDataFromArrayByValue(this.props.masterCountry, this.state.country === 'short_name' ? '' : this.state.country, true);
      if (countryObj) {
        this.props.dispatch(change('LocationMasterModalForm', 'countryID', countryObj.id));
        this.getFilteredStatesList(countryObj.id);
      }
      let stateObj = extractDataFromArrayByValue(this.state.filteredStatesByCountry, this.state.administrative_area_level_1 === 'short_name' ? '' : this.state.administrative_area_level_1, false);
      if (stateObj) {
        this.setState({ standardTime: stateObj.standardTime, daylightSavingTime: stateObj.daylightSavingTime });
        this.props.dispatch(change('LocationMasterModalForm', 'stateID', stateObj.id));
      }
      let address = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
        this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;

      this.setState({ Address: address });
    });
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    if (input.name === 'countryID') {
      this.getFilteredStatesList(selectedRecord.value);
    } else if (input.name === 'stateID') {
      let stateObj = this.props.masterState.find((Obj) => Obj.id === selectedRecord.value);
      this.setState({
        standardTime: stateObj && stateObj.standardTime,
        daylightSavingTime: stateObj && stateObj.daylightSavingTime,
      });
    } else if (input.name === 'taxonomyCodeIds') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 'Other') {          
          this.props.dispatch(change('LocationMasterModalForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: true });
        } else {          
          this.props.dispatch(change('LocationMasterModalForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: false });
        }
      } else {
        
        this.setState({ displayOtherTaxonomy: false });
      }
    }
  }

  
  getFilteredStatesList = (countryID) => {
    this.setState((prevState, props) => {
      let allStates = this.state.masterState || [];
      if (allStates) {
        let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
        return {
          filteredStatesByCountry: filteredStates,
        };
      } else {
        return {
          filteredStatesByCountry: [],
        };
      }
    });
  }
  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
    this.props.ResetLocationDetails()
  };
  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: moment(value).format() });
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      // console.log('labelName...........',labelName)
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name,
        'id': this.state.locationID || 0,
      };
      this.setState({ isFieldExist: true });
      this.props.checkFieldExistence(postData);
    }
  };
  checkIsSameOrBefore = (date1, date2) => {
    return moment(date1).isSameOrBefore(date2);  
  }

  checkIsBefore = (date1, date2) => {
    return moment(date1).isBefore(date2);  
  }

  handleSave = (formProps) => {

    if (this.state.Address === null || this.state.Address === '') {
      this.setState({ isValidAddress: false });
      return null;
    }
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formProps.locationMileageReimbursementRateModel = this.props.locationMileageReimbursementRate.map((data)=>{
      let obj = {
        'fromDate':data.fromDate?moment(data.fromDate).format('YYYY-MM-DD') + 'T' + moment(data.fromDate).format('HH:mm:ss'):null,
        'id': data.id?data.id:0,
        'locationId': data.locationId? data.locationId: (this.props.locationId === null ? 0 : this.props.locationId),
        'reimbursementRate': data.reimbursementRate||null,
        'toDate': data.toDate? moment(data.toDate).format('YYYY-MM-DD') + 'T' + moment(data.toDate).format('HH:mm:ss'):null
      }
      return obj
    })
    if(formProps.mileageRate){
       formProps.mileageRate = formProps.mileageRate==="NA"?null:parseFloat(formProps.mileageRate.trim().split('$')[0])
    }
    
    formProps['id'] = this.state.locationID!==null?this.state.locationID:0
    formProps['locationName'] = formProps.locationName ? formProps.locationName.trim() : null;    
    formProps['address'] = this.state.Address;
    formProps['latitude'] = this.state.latitude;
    formProps['longitude'] = this.state.longitude;
    formProps['standardTime'] = this.state.standardTime;
    formProps['daylightSavingTime'] = this.state.daylightSavingTime;
    formProps['countyCode'] = formProps.countyCode ? formProps.countyCode.trim() : null;    
    formProps['facilityName'] = formProps.facilityName ? formProps.facilityName.trim() : null;        
    formProps['apartmentNumber'] = formProps.apartmentNumber ? formProps.apartmentNumber.trim() : null;        
    formProps['billingApartmentNumber'] = formProps.billingApartmentNumber ? formProps.billingApartmentNumber.trim() : null;            
    formProps.officeStartHour = this.state.officeStartHour ? moment(this.state.officeStartHour).format('YYYY-MM-DD') + 'T' + moment(this.state.officeStartHour).format('HH:mm:ss') : null;
    formProps.officeEndHour = this.state.officeEndHour ? moment(this.state.officeEndHour).format('YYYY-MM-DD') + 'T' + moment(this.state.officeEndHour).format('HH:mm:ss') : null;
    formProps.taxonomyCode =  this.state.displayOtherTaxonomy ? formProps.taxonomyCode.trim() : formProps.taxonomyCodeIds;

    // console.log(JSON.stringify(formProps));
    this.props.saveLocationMaster(formProps, this.props.loginUserID);
    this.props.clearFieldErrorArray();
    this.setState({ open: false,reimbursementRateRequired:false,fromDateRequired:false });
    this.props.closeDialog();
    this.props.ResetLocationDetails()
  };

  onRateDateChange = (input, value, i, type) => {
    input.onChange(moment(value).format());
    if(type === 'FROM DATE')
    {
        this.setState({reimbursementRateRequired:true})
        let startDate = this.state.startDate;

        _.update(startDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ startDate: startDate }, ()=>{                  
          document.getElementsByName(`locationMileageReimbursementRateModel[${i}].toDate`)[0].focus();  
      });

      let selectorPayerBillingRate = this.props.locationMileageReimbursementRate || [];
      let selectedDateIndex  = i;//this.state.startDate.length - 1;      
      
      this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${i}].fromDate`,moment(value).format('MM-DD-YYYY') || null));

      if(selectedDateIndex > 0) {

        let endDate = this.state.endDate;              
        let endDateOfLastSameActivity  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");
        let lastIndexOfEndDate = 0;

        selectorPayerBillingRate.forEach((obj, index) => {        
          if(lastIndexOfEndDate !== null && index != selectedDateIndex && index <= selectedDateIndex)
          {      
            lastIndexOfEndDate = index;
          }
        });

        endDate[lastIndexOfEndDate] = this.state.startDate[lastIndexOfEndDate]  != null && endDateOfLastSameActivity > this.state.startDate[lastIndexOfEndDate]  ? this.state.startDate[lastIndexOfEndDate] : endDateOfLastSameActivity;      
      
        if(lastIndexOfEndDate >= this.props.locationMileageReimbursementRate.length -1)
        {
          lastIndexOfEndDate = lastIndexOfEndDate - 1;
        }
        if(moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') !== 'Invalid date' && this.checkIsSameOrBefore(moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY'), moment(startDate[lastIndexOfEndDate]).format('MM-DD-YYYY'))) {        
          endDate[lastIndexOfEndDate] = moment(startDate[lastIndexOfEndDate]).format('MM-DD-YYYY');
        }
        this.setState({endDate: endDate},()=>{                 
          this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${lastIndexOfEndDate}].toDate`,moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') || null));
        });
      }
    }
    else if(type === 'TO DATE')
    {
        let endDate = this.state.endDate;

        _.update(endDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });
        
        this.setState({ endDate: endDate }, ()=>{                  
          document.getElementsByName(`locationMileageReimbursementRateModel[${i}].fromDate`)[0].focus();           
      });
    }
  }

  addOneDay = (date) => {    
    date.setDate(date.getDate() + 1);
    return date;
  }
  onRateChange = ()=>{
    this.setState({
      fromDateRequired:true,
      reimbursementRateRequired:true

    })
  }


  addRateRow = () => { };
  removeRateRow = (i) => { };
 

  renderBillingRateTemplate = ({ fields }) => {
    
    this.removeRateRow = (index) => {

     if(fields.length===2){
      this.setState({reimbursementRateRequired:false,fromDateRequired:false});
     }
     let startDate = this.state.startDate;  
     let startDateWithIndex = this.state.startDate[index];
      for(let j = 0; j < this.state.startDate.length; j++)
      {
          if(startDate[j] === undefined)
          {
            startDate[j] = null;
          }
      }
      fields.remove(index);
      let selectedEndDateValue = this.state.endDate[index];
      this.setState({
        startDate: startDate.filter((_, i) => i !== index),
        endDate: this.state.endDate.filter((_, i) => i !== index)
      },() => {
        if(startDateWithIndex != undefined) {
          let endDate = this.state.endDate;
          let startDate = this.state.startDate;        
          let selectorPayerBillingRate = this.props.locationMileageReimbursementRate.filter((_, i) => i !== index) || [];
          let selectedDateIndex  = index;//,indexCount1 = 0;
          let endDateOfPreviousRange  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");       
          selectorPayerBillingRate.forEach((obj, i) => {   
              let selectedDateIndex  = index - 1;  
              if(selectedDateIndex < 0)
                selectedDateIndex = 0;
                let lastIndexOfEndDate = 0, indexCount = 0;
                  let endDatePrevious = this.state.startDate[i] > endDateOfPreviousRange ? this.state.startDate[i] : endDateOfPreviousRange;
                    selectedDateIndex  = index;//this.state.startDate.length - 1; '
                    let therapyPreviousIndex = 0, therapyNextIndex = 0, flag = true;                     
                    let selectorPayerBillingRate = this.props.locationMileageReimbursementRate || [];                  
                    selectorPayerBillingRate.forEach((obj, i) => {        
                            
                          if(i < selectedDateIndex)   
                            therapyPreviousIndex = i;
                          else if(i >= selectedDateIndex && flag) {
                            therapyNextIndex = i;
                            flag = false;
                          }  
                          indexCount = indexCount + 1;
                            
                          if(i != selectedDateIndex)
                          {      
                            lastIndexOfEndDate = i;
                          }
                        });

                        if(indexCount > 1 && indexCount >= this.props.locationMileageReimbursementRate.length ) {
                          if(therapyPreviousIndex >= 0){
                                if(therapyNextIndex === 0) {
                                  endDate[therapyPreviousIndex] = null;
                                }
                                else {
                                  endDate[therapyPreviousIndex] = moment(startDate[therapyNextIndex]).subtract(1, "days");
                                }
                              this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${therapyPreviousIndex}].toDate`, endDate[therapyPreviousIndex]));
                          }
                          else if(selectedDateIndex === lastIndexOfEndDate || (indexCount + 1) === lastIndexOfEndDate || (selectedDateIndex - 1) === lastIndexOfEndDate){
                            endDate[lastIndexOfEndDate] = null;
                            this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${lastIndexOfEndDate}].toDate`, null));
                          }
                          else if(lastIndexOfEndDate < indexCount) {                                
                            endDate[lastIndexOfEndDate] = moment(startDate[selectedDateIndex]).subtract(1, "days");
                          }   
                          else if(startDate[selectedDateIndex - 1] != null && this.checkIsSameOrBefore(moment(endDatePrevious).format('MM-DD-YYYY'), moment(startDate[selectedDateIndex - 1]).format('MM-DD-YYYY'))) {    
                            endDate[selectedDateIndex - 1] = startDate[selectedDateIndex - 1];
                          }                           
                          else {
                            if(endDatePrevious  != undefined && moment(endDatePrevious).format('MM-DD-YYYY') !== 'Invalid date'){
                              endDate[selectedDateIndex - 1] = endDatePrevious;
                            }
                            else {
                              endDate[selectedDateIndex - 1] =  selectedEndDateValue;
                            }
                          }
                          this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${selectedDateIndex - 1}].toDate`, endDate[selectedDateIndex - 1]));
                        } else if(indexCount > 1 && indexCount < this.props.locationMileageReimbursementRate.length ){
                          endDate[selectedDateIndex - 1] = null;
                          this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${selectedDateIndex - 1}].toDate`, null));
                        } else {
                          endDate[lastIndexOfEndDate] = null;
                          this.props.dispatch(change('LocationMasterModalForm', `locationMileageReimbursementRateModel[${lastIndexOfEndDate}].toDate`, null));
                        }

                  this.setState({endDate: endDate},()=>{
                    document.getElementsByName(`locationMileageReimbursementRateModel[${i}].fromDate`)[0].focus(); 
                  });
          });
        }
      });
    };

    this.addRateRow = (e) => {
      this.setState({reimbursementRateRequired:true,fromDateRequired:true });
      fields.push({});
    };

    
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    return (
      <div>
        {fields.map((locationMileageReimbursementRateModel, i) =>{
          if(this.state.startDate[i] === undefined)
          {   
            _.update(startDate, `[${i}]`, function (n) {
              return null;
            });          
            this.setState({ startDate: startDate });
          }   
          if(this.state.endDate[i] === undefined)
          {   
            _.update(endDate, `[${i}]`, function (n) {
              return null;
            });          

            this.setState({ endDate: endDate });
          }              
        return (
          <div id="currentDiv" className="row" key={i}>
            <div className= {this.state.fromDateRequired? "col-sm-3 require":"col-sm-3"}  >
                <Field
                    name={`locationMileageReimbursementRateModel[${i}].fromDate`}
                    placeholder="From Date"
                    locale="en-US"
                    minDate={(this.state.startDate[i - 1] !== undefined && this.state.startDate[i - 1] !== null ? (this.addOneDay(new Date(this.state.startDate[i - 1]))) : (this.state.endDate[i - 1] !== undefined && this.state.endDate[i - 1] !== null ? (this.addOneDay(new Date(this.state.endDate[i - 1]))) : new Date(1900, 9, 11)))}
                    //minDate={this.props.selectorPayerBillingRate && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1)) && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1))[0] && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1))[0].startDate !== undefined && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1))[0].startDate !== null   ?  (this.state.lastIndexOfEndDate !== null && this.props.selectorPayerBillingRate && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0] && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].startDate != null  ? (this.addOneDay(new Date(this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].startDate))) : (this.state.lastIndexOfEndDate !== null && this.props.selectorPayerBillingRate && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0] && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].endDate != null  ? (this.addOneDay(new Date(this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].endDate))) : new Date(1900, 9, 11))) : new Date(1900, 9, 11)}
                    maxDate={this.state.endDate[i] ? this.state.endDate[i] : new Date(2120, 9, 11)}                    
                    //minDate={this.state.startDate[i-1] || new Date(2120, 9, 11)}
                    selected={this.state.startDate[i] || null}
                    onDateChange={(input, value) => this.onRateDateChange(input, value, i, 'FROM DATE')}
                    openToYearSelection={true}
                    validate={this.state.fromDateRequired?[validateFromDate]:null}
                    component={renderDateField} />
            </div>
            <div className="col-sm-3">
              <Field
                name={`locationMileageReimbursementRateModel[${i}].toDate`}
                placeholder="To Date"
                locale="en-US"
                minDate={this.state.startDate[i] || null}
                selected={this.state.endDate[i] || null}
                onDateChange={(input, value) => this.onRateDateChange(input, value, i, 'TO DATE')}
                openToYearSelection={true}
                disabled={true}
                component={renderDateField} />
            </div>
            <div className={this.state.reimbursementRateRequired?"col-sm-3 require":"col-sm-3"}>                
                <Field
                     name={`locationMileageReimbursementRateModel[${i}].reimbursementRate`}
                    type="text"
                    // disabled={true}
                    maxLength="8"
                    onChange={this.onRateChange}
                    label="Reimbursement rate"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                    validate={this.state.reimbursementRateRequired?[validateReimbursementRate]:null}
                  />
            </div>           
            <div className="col-sm-3">
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className="additem removeitem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  : ''}
                  <button className="additem" title="Add Rate" onClick={(e) => this.addRateRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  
                    <button className="additem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  
                </div>
              }
            </div>
          </div>
          );
        })
      }
      </div>
    );
  };


  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.handleSave.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (<div>
      <Dialog
        className="custom_modal"
        title={this.state.locationID ? 'Edit Location' : 'Add Location'}
        modal={false}
        actions={actions}
        open={this.state.open}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" noValidate >
              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>General Office Information</h5>
                  <div className="row">              
                    <div className="col-sm-6 require">
                      <Field
                        name="billingTaxId"
                        label="Tax ID #(Professional)"
                        maxLength='9'
                        component={renderTextField}
                        normalize={isInteger}
                      />
                    </div>
                    <div className="col-sm-4 require">
                        <Field
                          name="phone"
                          type="text"
                          maxLength="14"
                          label="Phone Number"
                          normalize={normalizeMobile}
                          component={renderTextField} />
                      </div>
                      <div className="col-sm-2">
                        <Field
                          name="extentionNumber"
                          type="text"
                          maxLength="10"
                          label="Ext."
                          component={renderTextField}
                          normalize={isInteger} />
                      </div>
                    <div className="col-sm-6 mt-35">
                      <Field
                        name="timeZoneId"
                        label="Time Zone"                
                        options={this.props.masterTimeZoneEVV}
                        handleNewRequest={this.handleNewRequest}                   
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-6 ">
                      <Field
                        name="officeStartHour"
                        placeholder="Start Time"
                        fullWidth={true}
                        component={renderTimePicker}
                        selected={this.state.officeStartHour}
                        onDateChange={this.onDateChange}
                      />
                    </div>
                    <div className="col-sm-6 ">
                      <Field
                        name="officeEndHour"
                        placeholder="End Time"
                        fullWidth={true}
                        component={renderTimePicker}
                        selected={this.state.officeEndHour}
                        onDateChange={this.onDateChange}
                      />
                    </div>
                    {/* <div className="col-sm-6">
                      <Field
                        name="countyCode"
                        type="text"
                        maxLength='20'
                        label="County Code"
                        component={renderTextField} />
                    </div>  */}                      
                  </div>
                  <div className='row'>
                    <div className="col-sm-12 require">
                        <Field
                          name="locationName"
                          label="Location Name (Used for internal purposes only. Will not be displayed on claim)"
                          onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Location name')}
                          customError={displayCustomError('LOCATIONNAME', this.props.fieldError)}
                          normalize={isValidNameWithSpace}
                          maxLength='100'
                          component={renderTextField}
                        />
                      </div>
                  </div>
                  <div className='row'>
                    <div className="col-sm-12">
                      <Field
                        name="locationDescription"
                        label="Description"
                        type="text"
                        maxLength="1000"
                        // normalize ={isValidNameWithSpace}
                        component={renderTextArea}
                      />
                      <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                    </div>
                    </div>

                    <div className='row'>
                    <div className="col-sm-12 mt-2">
                      <h5>Mileage reimbursement rate</h5>
                    </div>
                    </div>

                    <div className='row'>
                    <div className="col-sm-12">
                      <Field
                        name="mileageRate"
                        label="Default Federal Rate"
                        type="text"
                        disabled = {true}
                        maxLength="100"
                        component={renderTextField}
                      />
                    </div>
                    </div>

                    <div className='row'>
                      <FieldArray name="locationMileageReimbursementRateModel" component={this.renderBillingRateTemplate} />
                    </div>

                </div>

                
              </div>

              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Facility Service Location Information / Box 32</h5>
                  <div className="panel_title">
                      <h7 style={styles.font}>*Theralytics will use this address in Box 32 of the claim form if POS 11 is selected. If the service address is home (POS 12) or another location then Theralytics will display that address in Box 32.</h7>                    
                  </div>
                  <div className="row">   
                    <div className="col-sm-6 require mt-35">
                      <Field
                        name="facilityCode"
                        label="Facility Type"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterPatientLocation}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className='col-sm-6 require'> 
                      <Field
                        name="facilityNPINumber"
                        label="Facility NPI Number (Box 32a)"
                        maxLength='10'
                        component={renderTextField}
                        normalize={isInteger}
                        //validate={this.props.agencyName.toUpperCase() !== 'ARROWS' ? [validatefacilityNPINumber] : null}   
                      />
                    </div>                    
                    {/* <div className="col-sm-6">
                      <Field
                        name="facilityProviderNumber"
                        label="Facility Provider Number"
                        maxLength='10'
                        component={renderTextField}
                        normalize={isInteger}
                      />
                    </div> */}
                    <div className="col-sm-12 require">
                      <Field
                        name="facilityName"
                        label="Facility Name (Name of Business)"
                        onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Location name')}
                        customError={displayCustomError('LOCATIONNAME', this.props.fieldError)}
                        normalize={isValidNameWithSpace}
                        maxLength='500'
                        component={renderTextField}
                      />
                    </div>
                  </div>
                  <div className='row'>
                      <div className="col-sm-12 require">                        
                        <GooglePlaceAutocomplete
                          getFullAddress={this.GetFullAddress}
                          id="Address"
                          labelText="Address"
                          errorText={this.state.isValidAddress ? '' : 'Please enter address.'}
                          value={this.state.Address}
                          isFullAddressEmpty={this.IsFullAddressEmpty}
                          // hintText="Enter Address"
                          // value= {this.state.address}
                        />                        
                      </div>               
                    </div>
                    <div className='row'>
                      <div className="col-sm-6">
                        <Field
                          name="apartmentNumber"
                          type="text"
                          maxLength='15'
                          label="Apt/Unit"
                          normalize={isValidApartmentWithSpace}
                          component={renderTextField} />
                      </div>
                      <div className="col-sm-6 require mt-35">
                        <Field
                          name="countryID"
                          label="Country"
                          handleNewRequest={this.handleNewRequest}
                          options={this.props.masterCountry}
                          component={renderAutoCompleteSingleSelect}
                        />
                      </div>               
                    </div>
                    <div className='row'>
                      <div className="col-sm-6 require">
                        <Field
                          name="city"
                          label="City"
                          maxLength='50'
                          normalize={isValidNameWithSpace}
                          component={renderTextField}
                        />
                      </div>
                      <div className="col-sm-6 require mt-35">
                        <Field
                          name="stateID"
                          label="State"
                          handleNewRequest={this.handleNewRequest}
                          options={this.state.filteredStatesByCountry}
                          component={renderAutoCompleteSingleSelect}
                        />
                      </div>      
                    </div>
                    <div className='row'>
                      <div className="col-sm-6 require">
                        <Field
                          name="zip"
                          type="text"
                          maxLength="10"
                          label="Zip code"
                          normalize={normalizeZipCode}
                          component={renderTextField} />
                      </div>  
                    </div>
                </div>
              </div>

              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Billing Provider Information / Box 33</h5>
                  <div className="panel_title">
                    <h7 style={styles.font}>*If left blank, Theralytics will use the Facility Service Location Information in Box 32_. If your payer requires a taxonomy code in Box 33b please enter it below.</h7>                    
                  </div>
                  <div className="row">   
                    <div className="col-sm-6 require mt-35">
                      <Field
                        name="taxonomyCodeIds"
                        label="Taxonomy Codes"
                        handleNewRequest={this.handleNewRequest}
                        options={this.state.Taxonomylist}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    {this.state.displayOtherTaxonomy && <div className="col-sm-6 require">
                      <Field
                        name="taxonomyCode"
                        type="text"
                        maxLength='100'
                        label="Billing Provider Taxonomy Code"                    
                        component={renderTextField} 
                        validate={this.state.displayOtherTaxonomy ? [validateOtherTaxonomy] : null}
                        />
                    </div>} 
                    <div className="col-sm-6">
                      <Field
                        name="billingNPINumber"
                        label="Billing NPI Number / Box 33a"
                        maxLength='10'
                        component={renderTextField}
                        normalize={isInteger}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                        <Field
                          name="billingProviderInfo"
                          label="Billing Provider Name"
                          type="text"
                          maxLength="250"
                          // normalize ={isValidNameWithSpace}
                          component={renderTextField}
                        />
                     </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <Field
                        name="billingAddress"
                        type="text"
                        maxLength="55"
                        label="Address"
                        // normalize = {isValidNameWithSpace}
                        fullWidth={true}
                        component={renderTextField}/>
                    </div>
                    <div className="col-sm-6">
                      <Field
                        name="billingApartmentNumber"
                        type="text"
                        maxLength='15'
                        label="Apt/Unit"
                        normalize={isValidApartmentWithSpace}
                        component={renderTextField} />
                    </div>                  
                    <div className="col-sm-6 mt-35">
                      <Field
                        name="billingCountryID"
                        label="Country"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterCountry}
                        component={renderAutoCompleteSingleSelect}/>
                    </div>
                    <div className="col-sm-6">
                      <Field
                        name="billingCity"
                        type="text"
                        label="City"
                        maxLength='50'
                        normalize={isValidNameWithSpace}
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-6 mt-35">
                      <Field
                        name="billingStateID"
                        label="State"
                        handleNewRequest={this.handleNewRequest}
                        options={this.state.filteredStatesByCountry}
                        component={renderAutoCompleteSingleSelect} />
                    </div>                  
                    <div className="col-sm-6">
                      <Field
                        name="billingZip"
                        type="text"
                        normalize={normalizeZipCode}
                        maxLength={10}
                        label="Zip Code"
                        component={renderTextField} />
                    </div>
                     
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    </div>
    );
  }
}
const selector = formValueSelector('LocationMasterModalForm');
LocationMasterModal = reduxForm({
  form: 'LocationMasterModalForm',
  validate,
  enableReinitialize: true,
})(LocationMasterModal);

function mapStateToProps(state, ownProps) {

  let masterCountry = [], masterState = [], masterPatientLocation = [], masterTimeZoneEVV = [];
  let defaultSelectedCountry = null;
  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
  let countryName = agencyName.toUpperCase() === CONVERGENCY ? 'Canada' : 'US';

  if (state.location_master.master_data) {
    let countryObj = (state.location_master.master_data.masterCountry || []).find((obj) => obj.countryName === countryName);
    defaultSelectedCountry = countryObj && countryObj.id;
    masterCountry = state.location_master.master_data.masterCountry || [];
    masterState = state.location_master.master_data.masterState || [];
    masterPatientLocation = state.location_master.master_data.masterPatientLocation || [];
    masterTimeZoneEVV = state.location_master.master_data && state.location_master.master_data.masterEVVDetails ? state.location_master.master_data.masterEVVDetails.filter((obj) => obj.category === 'TIMEZONE' && obj.rendSvsSupported === 'Yes') : [];
  }

  let initialData = {
    countryID: defaultSelectedCountry,
    locationMileageReimbursementRateModel: [{}],
  };


  let locationMileageReimbursementRateModel = [];

  
  
  if (ownProps.locationId && state.location_master.masterLocationDetails) {
    initialData = state.location_master.masterLocationDetails.data;
    if(state.location_master.masterLocationDetails.data.taxonomyCode !== '106S00000X' && state.location_master.masterLocationDetails.data.taxonomyCode !== '106E00000X' && state.location_master.masterLocationDetails.data.taxonomyCode !== '103K00000X') 
      {
        initialData.taxonomyCode = state.location_master.masterLocationDetails.data.taxonomyCode;
        initialData.taxonomyCodeIds = 'Other';
      }
      else {      
        initialData.taxonomyCodeIds = state.location_master.masterLocationDetails.data.taxonomyCode;
      }    
    }
    
    if (state.location_master.masterLocationDetails && state.location_master.masterLocationDetails.data && state.location_master.masterLocationDetails.data.locationMileageReimbursementRateModel.length > 0) {
  
      state.location_master.masterLocationDetails.data.locationMileageReimbursementRateModel.filter((data, i) => {
      
        locationMileageReimbursementRateModel.push({
            'id': data.id ? data.id : 0,
            'locationId': data.locationId,          
            'fromDate': data.fromDate,
            'toDate': data.toDate,
            'reimbursementRate': data.reimbursementRate && showNormalizedRate(data.reimbursementRate),           
          });
        
        return locationMileageReimbursementRateModel;
      });
      initialData['locationMileageReimbursementRateModel'] =locationMileageReimbursementRateModel && locationMileageReimbursementRateModel.length > 0 ? locationMileageReimbursementRateModel : [{}];
    } else {      
      initialData['locationMileageReimbursementRateModel'] = [{}];
    }
  return {
    defaultSelectedCountry,
    masterCountry,
    masterState,
    masterPatientLocation,
    loading: state.location_master.loading,
    master_data: state.location_master.master_data,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialData,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
    description: selector(state, 'locationDescription'),
    masterLocationDetails: state.location_master.masterLocationDetails,
    masterTimeZoneEVV: masterTimeZoneEVV,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    locationMileageReimbursementRate: selector(state, 'locationMileageReimbursementRateModel'),
  };
}
export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, getMasterData, saveLocationMaster, getmasterLocationDetails,ResetLocationDetails })(LocationMasterModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/location-master/location-master-modal.js